const planPerformanceMetricsMessages = {
  pageTitles: {
    titleAndSubtitle: {
      title: 'Plan Performance',
      subTitle: 'Showing employer claims data from ',
    },
  },
  pageTitlesofPendingClaimStatus: {
    titleAndSubtitle: {
      title: 'Pending Claims Status Distribution',
      subTitle:
        'Showing claims lag report. When viewing month by month, the claims incurred vs claims paid create a triangle shape of data. This illustrates how quickly a claim will be paid after it is incurred. The vertical month column shows the month incurred and the horizontal month row shows the claim paid month.',
    },
  },
  pageTitlesofRejectedClaimStatus: {
    titleAndSubtitle: {
      title: 'Rejected Claims',
      subTitle: 'Showing details of rejected claims for the group from  ',
    },
    REJECTED_CLAIMS_PERCENT_TABLE: {
      TITLE: 'Rejected Claims Trend',
      SUBTITLE:
        'The table shows count and percentage of rejected each month and as percentage of total claims',
      SORTFIELD: 'member_unique_id',
      SORTORDER: 1,
    },
    REJECTED_CLAIMS_TABLE: {
      TITLE: 'Rejected Claims by',
      SUBTITLE:
        'You can select to view the rejected claims by Members or by Providers',
    },
  },
  specificDeductible: {
    title: 'Specific deductibles',
    subTitle: 'To see more about the specific deductible click on a category',
  },
  breadCrumb: {
    text: 'text',
    summary: 'Rejected-Claims',
  },
  buttonText: {
    download: 'Download',
    queryData: 'Query Data',
    submit: 'Submit',
  },
  cardText: {
    members: 'Members',
    totalCost: 'Total Cost',
    medical: 'Medical',
    rx: 'Rx',
    pmpm: 'PMPM',
    pepm: 'PEPM',
  },
  currencySymbol: {
    dollar: '$',
  },
  pendingClaims: 'Pending Claims',
  rejectedClaimsDropdownValues: ['Members', 'Providers'],
  NO_DATA_CONTENT: 'No Members Data',
};

export default planPerformanceMetricsMessages;
